module.exports = __webpack_public_path__ + "assets/d85eb1d12295b8c551ebab6d1dd79c4e.png";